import { Controller } from "@hotwired/stimulus"

// Makes a group of inputs mutually exclusive: once one has a value, the
// others are made read-only until it is cleared again. Read-only (not
// disabled) so a cleared field is still submitted and overwrites the old value.
// A value of 0 counts as empty. An optional message target is shown while
// any input is locked.
//
// Usage:
//   <div data-controller="exclusive-inputs">
//     <input data-exclusive-inputs-target="input" data-action="input->exclusive-inputs#update">
//     <input data-exclusive-inputs-target="input" data-action="input->exclusive-inputs#update">
//     <div data-exclusive-inputs-target="message" class="d-none">Only one, please.</div>
//   </div>
export default class extends Controller {
  static targets = ["input", "message"]

  connect() {
    this.update()
  }

  update() {
    const filled = this.inputTargets.find((input) => this.hasValue(input))

    this.inputTargets.forEach((input) => {
      input.readOnly = Boolean(filled) && input !== filled
    })

    if (this.hasMessageTarget) {
      this.messageTarget.classList.toggle("d-none", !filled)
    }
  }

  hasValue(input) {
    const value = input.value.trim()
    if (value === "") return false
    return Number(value) !== 0
  }
}
